module.exports = "<div>\n    <div class=\"my-gallery\">\n        <a :href=\"firstImage\" class=\"o-button o-button--white\">{{ btnLabel }}</a>\n    </div>\n    <lightbox id=\"mylightbox\" :images=\"lastImages\" :image_class=\" 'img-responsive img-rounded' \" :album_class=\" 'lightbox-album' \"\n        :options=\"options\">\n    </lightbox>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/gallery/gallery.vhtml
// module id = 263
// module chunks = 0